
//Components
import { AppBar, Toolbar, IconButton } from '@mui/material';
//Icons
import MenuIcon from '@mui/icons-material/Menu';
import logoSecundary from 'Assets/images/logo.png';
import MenuAccount from 'Core/containers/Header/.components/menuAccount';
import ChangePassword from './.components/changePassword';

//Redux
import { useDispatch, useSelector } from 'react-redux';

//Actions
import { toggleSidebar } from 'Redux/actions';

//Styles
import './header.scss';

const Header = (props) => {
    const { changePreferences } = props;
    const dispatch = useDispatch();

    const open = useSelector(state => state.commonRedux.sidebarShow);

    const handleDrawer = () => {
        dispatch(toggleSidebar(!open))
        changePreferences(!open)
    }

    return (
        <AppBar className="app-header">
            <Toolbar className="app-header-toolbar">
                <IconButton
                    color="inherit"
                    onClick={() => handleDrawer()}
                    className="app-header-icon"
                    size="large">
                    <MenuIcon />
                </IconButton>
                <img src={logoSecundary} className="app-header-img" />
                <MenuAccount />
            </Toolbar>
            <ChangePassword />
        </AppBar>
    );
}
export default Header;